import React from 'react';

import './ToggleButtonItem.css';

interface Props {
  value: string;
  children: (JSX.Element | string)[];
  handleClick?: (value: string) => void;
  pressed?: boolean;
}

const ToggleButtonItem = React.forwardRef<HTMLButtonElement, Props>(
  ({ pressed, handleClick, value, children }, ref) => (
    <button
      ref={ref}
      className="toggle-button__item"
      type="button"
      aria-pressed={pressed}
      onClick={() => (handleClick ? handleClick(value) : null)}
    >
      {children}
    </button>
  ),
);

export default ToggleButtonItem;
